module.exports = __webpack_public_path__ + "static_portal/img/boat_and_erg.20d16bcd.jpg";